const getFAIState = (state) => {
  return state?.fai;
};

export { getFAIState };
